import { Component } from '@angular/core';

@Component({
  selector: 'hd-main-toolbar-right-menu',
  templateUrl: './main-toolbar-right-menu.component.html',
  styleUrls: ['./main-toolbar-right-menu.component.scss']
})
export class MainToolbarRightMenuComponent{
}
